/// <amd-module name="CodeCoverage/CodeCoverageCiTab/Components/CodeCoverageHtmlView" />
import * as Resources from "CodeCoverage/CodeCoverageCiTab/Resources";
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";

export interface ICodeCoverageHtmlViewProps {
    codeCoverageSummaryLink: string;
}

export class CodeCoverageHtmlView extends VssComponent<ICodeCoverageHtmlViewProps, {}> {
    public render(): JSX.Element {
        // sandbox="" on an iFrame will apply all restrictions
        return (
            <div className="cc-html-view flex-grow scroll-hidden">
                {// @ts-ignore TypeScript 4.0 upgrade
                this.isIFrameSandboxAvailable ? (
                    <div className="code-coverage-frame-part">
                        <iframe sandbox="" src={this.props.codeCoverageSummaryLink} className="code-coverage-summary-frame" />
                    </div>
                ) : (
                    <span>{Resources.UpgradeToModernBrowser}</span>
                )}
            </div>
        );
    }

    private isIFrameSandboxAvailable(): boolean {
        return "sandbox" in document.createElement("iframe");
    }
}
